import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontSize } from '../theme';

interface Props {
  items: string[];
  /** Point size of the item text. Default `pdfFontSize.sm`. */
  size?: number;
  /** Two columns for short items (admit-card instructions). */
  columns?: 1 | 2;
}

const styles = StyleSheet.create({
  grid: { flexDirection: 'row', flexWrap: 'wrap' },
  item: { flexDirection: 'row', marginBottom: 3 },
  num: { width: 14, fontWeight: 700, color: pdfColors.brand },
  text: { flex: 1, color: pdfColors.textSecondary, lineHeight: 1.4 },
});

/** Numbered instruction list. Each item stays whole across a page break. */
const NumberedList: React.FC<Props> = ({ items, size = pdfFontSize.sm, columns = 1 }) => (
  <View style={columns === 2 ? styles.grid : undefined}>
    {items.map((text, i) => (
      <View
        key={i}
        style={[styles.item, columns === 2 ? { width: '50%', paddingRight: 10 } : {}]}
        wrap={false}
      >
        <Text style={[styles.num, { fontSize: size }]}>{i + 1}.</Text>
        <Text style={[styles.text, { fontSize: size }]}>{text}</Text>
      </View>
    ))}
  </View>
);

export default NumberedList;
